import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged, filter, switchMap } from 'rxjs/operators';
import { SchoolSemester, SchoolSocioEmotionalDashboardFilter } from './school-socio-emotional-dashboard-filters.models';
import { ApiService } from '../../services/api.service';
import { Grade } from '../../school-dashboard/school-dashboard-filters/school-dashboard-grade-dropdowns.models';
import { AlertService } from '../../services/alert.service';


const GRADE_LEVELS_ENDPOINT = 'api/getGradeLevelsById/';
const SCHOOL_DASHBOARD_BASE_URL = 'api/schoolDashboard';
const SCHOOL_SEMESTERS_ENDPOINT = 'api/socioEmotionalSkillTestResult/school';
const STUDENT_NAME_SUGGESTIONS_ENDPOINT = 'studentsNamesSuggestions';

@Component({
  selector: 'app-school-socio-emotional-dashboard-filters',
  templateUrl: './school-socio-emotional-dashboard-filters.component.html',
  styleUrls: ['./school-socio-emotional-dashboard-filters.component.scss']
})
export class SchoolSocioEmotionalDashboardFiltersComponent implements OnInit {
  schoolId: string = localStorage.getItem('schoolId') || '';
  schoolName: string = localStorage.getItem('school_name') || '';

  searchControl = new FormControl('');
  filteredStudents: string[] = [];
  grades: Grade[] = [];
  semesters: SchoolSemester[] = [];

  currentFilters: SchoolSocioEmotionalDashboardFilter = {};

  @Output() filtersChanged = new EventEmitter<SchoolSocioEmotionalDashboardFilter>();

  constructor(private apiService: ApiService, private alertService: AlertService) { }

  ngOnInit(): void {
    this.loadGrades();
    this.setupNameAutocomplete();
  }

  setupNameAutocomplete(): void {
    this.searchControl.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      filter(value => value.length >= 3 || value.length === 0),
      switchMap(searchTerm => {
        this.currentFilters = { ...this.currentFilters, name: searchTerm };
        this.filtersChanged.emit(this.currentFilters);
        return this.fetchStudentSuggestions(searchTerm);
      })
    ).subscribe(results => {
      this.filteredStudents = results || [];
    });
  }

  fetchStudentSuggestions(name: string) {
    const apiUrl = `${SCHOOL_DASHBOARD_BASE_URL}/${this.schoolName}/${STUDENT_NAME_SUGGESTIONS_ENDPOINT}?name=${name}`;
    return this.apiService.get({ api: apiUrl });
  }

  loadGrades(): void {
    this.apiService.get({ api: GRADE_LEVELS_ENDPOINT + this.schoolId }).subscribe(
      (res: any) => {
        const unique = new Set(res.gradesLevels.map((g: any) => g.grade[0]));
        this.grades = Array.from(unique).map(g => ({ id: g.toString(), name: `Grado ${g}` }));
      },
      () => this.alertService.showError({ msg: 'Error al cargar grados' })
    );
  }

  handleGradeChange(selected: Grade[]): void {
    const selectedGrade = selected[0];
    this.currentFilters = {
      ...this.currentFilters,
      grade: selectedGrade?.id ?? ''
    };
    this.filtersChanged.emit(this.currentFilters);
  }

  handleSemesterChange(selected: SchoolSemester): void {
    this.currentFilters = {
      ...this.currentFilters,
      semester: selected[0]?.name || undefined
    };
    this.filtersChanged.emit(this.currentFilters);

  }



  setStudent(student: string) {
    this.searchControl.setValue(student);
    this.filteredStudents = [];
    this.filtersChanged.emit({ ...this.currentFilters, name: student });
  }

  openAutocomplete() {
    if (this.filteredStudents.length === 0 && this.searchControl.value.length >= 3) {
      this.fetchStudentSuggestions(this.searchControl.value).subscribe(results => {
        this.filteredStudents = results || [];
      });
    }
  }

  onAutocompleteClosed() {
    this.filteredStudents = [];
  }
}
